import { Model } from '@vuex-orm/core';
// eslint-disable-next-line import/no-cycle
import Event from '@/modules/event/store/model';

class Task extends Model {
  static entity = 'tasks';

  static primaryKey = 'uuid'

  static fields() {
    return {
      alertEnabled: this.attr(null),
      type: this.attr(null),
      name: this.attr(null),
      isPaused: this.attr(false),
      categoryId: this.attr(null),
      isActive: this.attr(null),
      buttons: this.attr(null),
      user: this.attr(null),
      uuid: this.attr(null),
      description: this.attr(null),
      valueConfigs: this.attr(null),
      duration: this.attr(null),
      schedule: this.attr(null),
      bradenScore: this.attr(null),
      events: this.hasMany(Event, 'taskId'),
      createdAt: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetch(id) {
        return this.get(`/tasks/${id}`);
      },
      fetchByUserAndGroup(userId, groupName) {
        return this.get(`users/${userId}/groups/${groupName}/tasks?alwaysShowSchedule=true`);
      },
      createTask(data) {
        return this.post('tasks', data);
      },
      updateTask(id, data) {
        return this.patch(`tasks/${id}`, data);
      },
      removeTask(id) {
        return this.delete(`/tasks/${id}`,
          {
            delete: id,
          });
      },
    },
  }
}

export default Task;
